<template>
    <div class="trend-chart" ref="trendChart"></div>
</template>

<script>

export default {
    data: function () {
        return {
            chartObj: "",
            data: ''
        }
    },
    props: [
        'chartData',
    ],
    mounted() {
        this.initChart();
    },
    methods: {
        // 图表初始化
        initChart() {
            this.chartObj = this.$echarts.init(this.$el);
            if (!this.chartData) return;
            var option = {
                tooltip: {
                    show: true,
                    axisPointer: {
                        type: "line"
                    },
                    trigger: "axis",
                    formatter: function (data) {
                        var index_data = data[0];
                        var mark_html = index_data.axisValue+'</br>'+index_data.marker+index_data.data+'%';
                        return mark_html;
                    }
                },
                backgroundColor: 'transparent',
                grid: {
                    top: 5,
                    bottom: 5,
                    left: 0,
                    right: 0
                },
                dataZoom: [{
                    type: 'inside',
                    startValue: (this.chartData[1].length - 180) < 0 ? 0 : this.chartData[1].length - 180,
                    end: 100
                }],
                xAxis: {
                    show: false,
                    type: 'category',
                    data: this.chartData[1],
                    boundaryGap: true
                },
                yAxis: {
                    show: false
                },
                series: {
                    type: "line",
                    name: "收益",
                    data: this.chartData[0],
                    symbol: "none",
                    lineStyle: {
                        width: 1,
                        shadowColor: "rgba(175, 52, 49, 1)",
                        shadowBlur: 10
                    },
                    areaStyle: {
                        color: {
                            type: 'linear',
                            colorStops: [{
                                offset: 0, color: "rgba(175, 52, 49, 0.4)"
                            }, {
                                offset: 1, color: "rgba(175, 52, 49, 0.2)"
                            }]
                        }
                    }
                }
            };

            this.chartObj.setOption(option);
            this.$emit('changeLoad', false);
        }
    }
}
</script>

<style lang="scss" scoped>
.trend-chart {
    width: 124px;
    height: 44px;
}
</style>
